import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const DrAnuradhaTikheYogaContent = () => {
  return (
    <DoctorDetailPage
      name="Dr. Anuradha Tikhe"
      specialization="Mind-Body Guide & Prenatal Yoga Expert"
      experience="16+ Years specializing in prenatal and postnatal wellness"
      degrees="BHMS, MPH (Mumbai), Certificate in Prenatal & Postnatal Yoga"
      quote="I believe I am becoming a pregnancy crafter who helps mothers feel strong, calm, and connected."
      sections={[
        {
          title: "My Philosophy on Prenatal Wellness",
          body: "I believe that the journey of pregnancy is an incredible opportunity to build a powerful connection between mind and body. My role isn't just to teach yoga poses; it's to guide you through a practice that reduces anxiety, improves physical comfort, and prepares you emotionally and physically for labour. We focus on safe, gentle movements that create space for your baby, and breathing techniques that will become your anchor during childbirth and beyond.",
        },
        {
          title: "Why I Partnered with Myprega",
          body: "Myprega understands that a mother's well-being is holistic. They are the only platform that truly integrates physical fitness and mental peace into the core medical plan. Here, yoga isn't an optional add-on; it's a fundamental part of ensuring a happy, healthy pregnancy, and I am honoured to lead that practice.",
        },
        {
          title: "Beyond the Clinic",
          body: "When I'm not teaching, I am an avid student of Ayurveda and love creating herbal teas. I find peace in nature and take long, silent walks to recharge. I believe in living the principles I teach, finding moments of stillness and gratitude in everyday life.",
        },
      ]}
      favorites={[
        { icon: "📖", label: "Favourite Book", value: "The Heart of Yoga by T.K.V. Desikachar" },
        { icon: "🎵", label: "Favourite Musician", value: "Deva Premal" },
        { icon: "🌿", label: "Favourite Pastime", value: "Creating herbal teas\nSilent nature walks\nPracticing mindfulness and gratitude" },
      ]}
    />
  );
};

export default DrAnuradhaTikheYogaContent;
